import type {FunctionComponent} from 'react';
import type {ReviewsItem} from '@app/components/reviews';
import {LandingReviews} from '@app/components/reviews';
import {LandingHeading, LandingParagraph, LandingSection} from '@tempo/landing';
import {SimpleGrid} from '@tempo/core';
import {useTranslation} from '@app/hooks/use-translation';

export const Testimonials: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['reviews']});

	const TESTI_REVIEWS: ReviewsItem[] = [
		{
			grade: 4,
			text: t('reviewslandingpage_text_review1_standalone-web'),
			pseudo: 'Lazare',
		},
		{
			grade: 5,
			text: t('reviewslandingpage_text_review2_standalone-web'),
			pseudo: 'Cherchepatator',
		},
		{
			grade: 5,
			text: t('reviewslandingpage_text_review3_standalone-web'),
			pseudo: 'BuddyBye',
		},
		{
			grade: 5,
			text: t('reviewslandingpage_text_review4_standalone-web'),
			pseudo: 'cccccrfyr',
		},
		{
			grade: 5,
			text: t('reviewslandingpage_text_review5_standalone-web'),
			pseudo: 'Christ&Alex',
		},
		{
			grade: 4,
			text: t('reviewslandingpage_text_review6_standalone-web'),
			pseudo: 'Baptiste Bily',
		},
		{
			grade: 4,
			text: t('reviewslandingpage_text_review7_standalone-web'),
			pseudo: 'vfr944',
		},
		{
			grade: 5,
			text: t('reviewslandingpage_text_review8_standalone-web'),
			pseudo: 'Mathilde Duboc',
		},
	];

	return (
		<LandingSection
			isContained
			description={
				<>
					<LandingHeading as="h2">
						{t('reviewslandingpage_title_customertestimonials_standalone-web')}
					</LandingHeading>
					<LandingParagraph color="text.neutral.primary.default" pb="40px">
						{t('reviewslandingpage_text_customertestimonials_standalone-web')}
					</LandingParagraph>
				</>
			}
		>
			<SimpleGrid columns={{sm: 2, md: 4}} spacing={0}>
				<LandingReviews items={TESTI_REVIEWS} />
			</SimpleGrid>
		</LandingSection>
	);
};
